import React from 'react'
import { FileRejection, useDropzone } from 'react-dropzone'

import UploadFileIcon from '@mui/icons-material/UploadFile'
import { Chip } from '@mui/material'

export default function UploadFileDropzoneChip({
  disabled,
  accept = '.mp3,.wav,.ogg,.webm,.flac,.m4a',
  label = 'Upload',
  onFile,
  onErrorMessage,
  onClick,
}: {
  disabled?: boolean
  accept?: string
  label?: string
  onFile?: (file: File) => void
  onErrorMessage?: (errorMessage: string) => void
  onClick?: () => void
}) {
  const onDrop = React.useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      onFile && onFile(acceptedFiles[0])
      if (fileRejections && fileRejections.length > 0) {
        onErrorMessage && onErrorMessage(`File type must be ${accept}`)
      }
    },
    [onFile],
  )

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept })

  const renderChip = () => {
    return (
      <Chip
        clickable
        disabled={disabled}
        size="medium"
        label={label}
        onClick={onClick}
        icon={<UploadFileIcon />}
      />
    )
  }

  if (onClick) return renderChip()

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {renderChip()}
    </div>
  )
}
